import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { ROUNDDOWN, ROUNDUP, XIF, IFS, OR } from '../utils/excel-functions-utils';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL } from './ter-protobomp-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { js_utils } from '../utils/frfr-js-utils';


/*
TODO


*/


//
export const derDraftel_terkk_ramfilteranauklizavanje_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_pods_input_state(),
    tipkomore: virtel_k.tipkomore,
    // unutrasnjaoplata: virtel_k.unutrasnjaoplata,
    vrstaprofila: virtel_m.vrstaprofila,
    msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih: virtel_m.mvisinaunutrasnjaizmedjupregradnih,
    // jos uvek trebaju za excel formule
    // ksirinaoznaka: virtel_k.ksirinaoznaka,
    kvisinaoznaka: virtel_k.kvisinaoznaka,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_ramfilteranauklizavanje_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let ramfuk_materijal_lim = null;
  if (tipmetalalima === "pocinkovani") {
    ramfuk_materijal_lim = _cpci.ramfuk_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    ramfuk_materijal_lim = _cpci.ramfuk_materijal_lim_prohrom;
  }
  //
  return {
    tipmetalalima,
    ramfuk_materijal_lim,
  };
};


// izracunavanje sirina i visine na osnovu pods_input
export const _derivat_ramfilteranauklizavanje_izracunaj_sirinu_b_i_visinu_h = (state, pods_input) => {
  //
  const {
    msirinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjupregradnih,
  } = pods_input;
  //
  const ZAZOR = 2;
  let ramfuk_sirinab = 0;
  let ramfuk_visinah = 0;
  let ramfuk_a = 0; // NJ 2024-09-16: Polja A i C su se koristila da bi mogli da proverimo sa crteža.
  let ramfuk_c = 0; // NJ 2024-09-16: Polja A i C su se koristila da bi mogli da proverimo sa crteža.
  if (msirinaunutrasnjaizmedjupregradnih > 0) {
    ramfuk_sirinab = msirinaunutrasnjaizmedjupregradnih - ZAZOR;
    // DL: E13 je polje koje se zove Širina B i ona se izracunava E13 = msirinaunutrasnjaizmedjupregradnih - zazor 2mm.
    // C, po formuli =E13-4
    ramfuk_c = ramfuk_sirinab - 4;
  }
  if (mvisinaunutrasnjaizmedjupregradnih > 0) {
    // DL: F13 je polje koje se zove Visina H (širina celog rama) i ona se izracunava F13 = mvisinaunutrasnjaizmedjupregradnih - zazor 2mm.
    ramfuk_visinah = mvisinaunutrasnjaizmedjupregradnih - ZAZOR;
    // A, po formuli =F13-10
    ramfuk_a = ramfuk_visinah - 10;
  }
  //
  return {
    ramfuk_sirinab,
    ramfuk_visinah,
    ramfuk_a,
    ramfuk_c,
  };
};


//
export const _derivat_terkk_ramfilteranauklizavanje_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    ramfuk_tipfiltera,
    ramfuk_sirinab,
    ramfuk_visinah,
    tervrstaprofila_50_ili_70,
  } = protobomp_superdata;
  //
  if (tervrstaprofila_50_ili_70 === "50") {
    // item.cnccrtez = "P01-09-A-35";
    _visina_20_ili_35 = 20;
    // _naziv_profil_komore_50_ili_70 = "P50";
  }
  if (tervrstaprofila_50_ili_70 === "70") {
    // item.cnccrtez = "P01-09-A-35";
    _visina_20_ili_35 = 35;
    // _naziv_profil_komore_50_ili_70 = "P70";
  }
  //
  const _izracunaj_crtez_TIPFILTERA = (ramfuk_tipfiltera) => {
    if (ramfuk_tipfiltera === "VRECASTI_25") {
      return 'A';
    } else if (ramfuk_tipfiltera === "PANELNI_48") {
      return 'A';
    } else if (ramfuk_tipfiltera === "PANELNI_92") {
      return 'A';
    } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
      return 'B';
    } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
      return 'B';
    }
    return '?';
  };
  const _izracunaj_crtez_DIMENZIJAFILTERA = (ramfuk_tipfiltera) => {
    if (ramfuk_tipfiltera === "VRECASTI_25") {
      return '25';
    } else if (ramfuk_tipfiltera === "PANELNI_48") {
      return '48';
    } else if (ramfuk_tipfiltera === "PANELNI_92") {
      return '92';
    } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
      return '25-48';
    } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
      return '25-92';
    }
    return '?';
  };
  //
  if (true) {
    // sklop
    if (family === 'terkk$ramfuk/SKLOP_RAMFUK') { // 1-
      // Naziv: „RAM FILTERA NA UKLIZAVANJE“ $ramfuk_sirinab „X“ $ramfuk_visinah „ -P“ $tervrstaprofila_50_ili_70 „FILTER“ $ramfuk_tipfiltera“-„ $tipmaterijala
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      // item.tip = 'A'; // DIRTY
      item.tip = _crtez_TIPFILTERA; // DIRTY
      item.ramfuk_sirinab = ramfuk_sirinab; // DIRTY
      item.ramfuk_visinah = ramfuk_visinah; // DIRTY
      item.tervrstaprofila_50_ili_70 = tervrstaprofila_50_ili_70; // DIRTY
      item.ramfuk_tipfiltera = ramfuk_tipfiltera; // DIRTY
      _naziv = 'RAM FILTERA NA UKLIZAVANJE ' + ramfuk_sirinab + 'x' + ramfuk_visinah + ' -P' + tervrstaprofila_50_ili_70 + ' FILTER ' + ramfuk_tipfiltera + SPACE + _materijal;
    }
    //
    //
    if (family === 'terkk$ramfuk/NOSAC_V_LEVI') { // 2. P1
      _naziv = 'FILTER NA UKLIZAVANJE-VERTIKALNI NOSAC LEVI P1';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P1'; // DIRTY
      item.razvijenamera1 = ramfuk_visinah - 8; // DIRTY
      item.razvijenamera2 = 57.7; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; // DIRTY
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P1“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P1';
    }
    //
    if (family === 'terkk$ramfuk/NOSAC_V_DESNI') { // 3. P2
      _naziv = 'FILTER NA UKLIZAVANJE-VERTIKALNI NOSAC DESNI P2';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P2'; // DIRTY
      item.razvijenamera1 = ramfuk_visinah - 8; // DIRTY
      item.razvijenamera2 = 57.7; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P2“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P2';
    }
    //
    if (family === 'terkk$ramfuk/NOSAC_OMEGA' || family === 'terkk$ramfuk/NOSAC_OMEGA_1_2' || family === 'terkk$ramfuk/NOSAC_OMEGA_2_2') { // 4. P3
      // ukoliko je iz dva dela 1od1 i 2od2
      _naziv = 'FILTER NA UKLIZAVANJE-NOSAC OMEGA P3';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P3'; // DIRTY
      item.tervrstaprofila_50_ili_70 = tervrstaprofila_50_ili_70; // DIRTY
      // item.razvijenamera1 = ramfuk_sirinab; // DIRTY
      const _izracunaj_razvijenamera2 = () => {
        if (ramfuk_tipfiltera === "VRECASTI_25" && tervrstaprofila_50_ili_70 === "50") {
          return 93;
        } else if (ramfuk_tipfiltera === "VRECASTI_25" && tervrstaprofila_50_ili_70 === "70") {
          return 123;
        } else if (ramfuk_tipfiltera === "PANELNI_48" && tervrstaprofila_50_ili_70 === "50") {
          return 116;
        } else if (ramfuk_tipfiltera === "PANELNI_48" && tervrstaprofila_50_ili_70 === "70") {
          return 145;
        } else if (ramfuk_tipfiltera === "PANELNI_92" && tervrstaprofila_50_ili_70 === "50") {
          return 160;
        } else if (ramfuk_tipfiltera === "PANELNI_92" && tervrstaprofila_50_ili_70 === "70") {
          return 190;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48" && tervrstaprofila_50_ili_70 === "50") {
          return 171;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48" && tervrstaprofila_50_ili_70 === "70") {
          return 201;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92" && tervrstaprofila_50_ili_70 === "50") {
          return 215;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92" && tervrstaprofila_50_ili_70 === "70") {
          return 245;
        }
        return -1;
      };
      item.razvijenamera2 = _izracunaj_razvijenamera2(); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P3“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P3';
      if (family === 'terkk$ramfuk/NOSAC_OMEGA_1_2') {
        _naziv += SPACE + "1od2";
        _cnc += '.1'; // SUFIX
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$ramfuk/NOSAC_OMEGA_2_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.2'; // SUFIX
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
    }
    //
    if (family === 'terkk$ramfuk/KLIZAC_GORNJI' || family === 'terkk$ramfuk/KLIZAC_GORNJI_1_2' || family === 'terkk$ramfuk/KLIZAC_GORNJI_2_2') { // 5. P4
      // ukoliko je iz dva dela 1od1 i 2od2
      _naziv = 'FILTER NA UKLIZAVANJE-KLIZAC GORNJI P4'; // DIRTY
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P4'; // DIRTY
      item.ramfuk_tipfiltera = ramfuk_tipfiltera; // DIRTY
      item.razvijenamera1 = ramfuk_sirinab; // DIRTY
      const _izracunaj_razvijenamera2 = () => {
        if (ramfuk_tipfiltera === "VRECASTI_25") {
          return 87.1;
        } else if (ramfuk_tipfiltera === "PANELNI_48") {
          return 110.1;
        } else if (ramfuk_tipfiltera === "PANELNI_92" && tervrstaprofila_50_ili_70 === 50) {
          return 154.1;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
          return 165.1;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
          return 209.1;
        }
        return -1;
      };
      item.razvijenamera2 = _izracunaj_razvijenamera2(); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P4“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P4';
      if (family === 'terkk$ramfuk/KLIZAC_GORNJI_1_2') {
        _naziv += SPACE + "1od2";
        _cnc += '.1'; // SUFIX
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$ramfuk/KLIZAC_GORNJI_2_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.2'; // SUFIX
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
    }
    //
    if (family === 'terkk$ramfuk/KLIZAC_DONJI' || family === 'terkk$ramfuk/KLIZAC_DONJI_1_2' || family === 'terkk$ramfuk/KLIZAC_DONJI_2_2') { // 6. P5
      // ukoliko je iz dva dela 1od1 i 2od2
      _naziv = 'FILTER NA UKLIZAVANJE-KLIZAC DONJI P5';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P5'; // DIRTY
      item.ramfuk_tipfiltera = ramfuk_tipfiltera; // DIRTY
      item.razvijenamera1 = ramfuk_sirinab; // DIRTY
      const _izracunaj_razvijenamera2 = () => {
        if (ramfuk_tipfiltera === "VRECASTI_25") {
          return 87.1;
        } else if (ramfuk_tipfiltera === "PANELNI_48") {
          return 110.1;
        } else if (ramfuk_tipfiltera === "PANELNI_92" && tervrstaprofila_50_ili_70 === 50) {
          return 154.1;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
          return 165.1;
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
          return 209.1;
        }
        return -1;
      };
      item.razvijenamera2 = _izracunaj_razvijenamera2(); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P5“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P5';
      if (family === 'terkk$ramfuk/KLIZAC_DONJI_1_2') {
        _naziv += SPACE + "1od2";
        _cnc += '.1'; // SUFIX
        item.ter_koji_deo_visedelnog = 1; // DIRTY
      }
      if (family === 'terkk$ramfuk/KLIZAC_DONJI_2_2') {
        _naziv += SPACE + "2od2";
        _cnc += '.2'; // SUFIX
        item.ter_koji_deo_visedelnog = 2; // DIRTY
      }
    }
    //
    if (family === 'terkk$ramfuk/GRANICNIK_288') { // 7. P6
      // ukoliko je iz dva dela 1od1 i 2od2
      _naziv = 'FILTER NA UKLIZAVANJE- GRANICNIK 288mm P6';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P6'; // DIRTY
      item.ramfuk_tipfiltera = ramfuk_tipfiltera; // DIRTY
      item.razvijenamera1 = 288; // DIRTY
      const _izracunaj_razvijenamera2 = () => {
        if (ramfuk_tipfiltera === "VRECASTI_25") {
          return (28 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "PANELNI_48") {
          return (51 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "PANELNI_92") {
          return (95 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
          return (106 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
          return (150 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        }
        return -1;
      };
      item.razvijenamera2 = _izracunaj_razvijenamera2(); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P6“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P6';
    }
    //
    if (family === 'terkk$ramfuk/GRANICNIK_493') { // 8. P7
      // ukoliko je iz dva dela 1od1 i 2od2
      _naziv = 'FILTER NA UKLIZAVANJE- GRANICNIK 493mm P7';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P7'; // DIRTY
      item.ramfuk_tipfiltera = ramfuk_tipfiltera; // DIRTY
      item.razvijenamera1 = 493; // DIRTY
      const _izracunaj_razvijenamera2 = () => {
        if (ramfuk_tipfiltera === "VRECASTI_25") {
          return (28 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "PANELNI_48") {
          return (51 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "PANELNI_92") {
          return (95 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
          return (106 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
          return (150 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        }
        return -1;
      };
      item.razvijenamera2 = _izracunaj_razvijenamera2(); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P7“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P7';
    }
    //
    if (family === 'terkk$ramfuk/GRANICNIK_593') { // 9. P7
      // ukoliko je iz dva dela 1od1 i 2od2
      _naziv = 'FILTER NA UKLIZAVANJE- GRANICNIK 593mm P7';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P7'; // DIRTY
      item.ramfuk_tipfiltera = ramfuk_tipfiltera; // DIRTY
      item.razvijenamera1 = 593; // DIRTY
      const _izracunaj_razvijenamera2 = () => {
        if (ramfuk_tipfiltera === "VRECASTI_25") {
          return (28 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "PANELNI_48") {
          return (51 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "PANELNI_92") {
          return (95 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_48") {
          return (106 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        } else if (ramfuk_tipfiltera === "VRECASTI_25_PANELNI_92") {
          return (150 + (ROUNDUP((ramfuk_sirinab / 610), 0) * 16));
        }
        return -1;
      };
      item.razvijenamera2 = _izracunaj_razvijenamera2(); // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P7“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P7';
    }
    //
    if (family === 'terkk$ramfuk/OJACANJE_V_UPROFIL_1') { // 10. P8.1
      _naziv = 'FILTER NA UKLIZAVANJE- VERTIKALNO OJACANJE P8.1';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P8_1'; // DIRTY
      item.razvijenamera1 = (ramfuk_visinah - 8); // DIRTY
      item.razvijenamera2 = 80.5; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P8.1“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P8.1';
    }
    if (family === 'terkk$ramfuk/OJACANJE_V_UPROFIL_2') { // 11. P8.2
      _naziv = 'FILTER NA UKLIZAVANJE- VERTIKALNO OJACANJE U PROFIL P8.2';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P8_2'; // DIRTY
      item.razvijenamera1 = (ramfuk_visinah - 8); // DIRTY
      item.razvijenamera2 = 87.5; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P8.2“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P8.2';
    }
    //
    if (family === 'terkk$ramfuk/DISTANCER_DUPLOG_KLIZACA') { // 12. P9
      _naziv = 'FILTER NA UKLIZAVANJE-DISTANCER DUPLOG KLIZACA P9';
      const _crtez_TIPFILTERA = _izracunaj_crtez_TIPFILTERA(ramfuk_tipfiltera);
      item.tip = _crtez_TIPFILTERA + '_P9'; // DIRTY
      item.razvijenamera1 = (ramfuk_visinah - 8); // DIRTY
      item.razvijenamera2 = 78.5; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      //
      // CNC crtež: „P01-24-„ TIPFILTERA „-„ $ramfuk_sirinab „-“ $ramfuk_visinah“-„DIMENZIJA FILTERA“-„ H20 ili H35(u zamisnosti od profila P50-P70)“-„ MATERIJAL (GS-pocinkovani lim SS-prohromski lim“-P9“
      _cnc = 'P01-24-' + _crtez_TIPFILTERA + MINUS + ramfuk_sirinab + MINUS + + ramfuk_visinah + MINUS + _izracunaj_crtez_DIMENZIJAFILTERA(ramfuk_tipfiltera) + "-H" + _visina_20_ili_35 + MINUS + _materijal + '-P9';
    }
    //
    //
  }
  //
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_ramfilteranauklizavanje_izracunaj_za_step_protobomp = (state, pods_input) => {
  //
  const {
    // ksirinaoznaka, 
    kvisinaoznaka,
  } = pods_input;
  const {
    kolicina, ramfuk_tipfiltera, tervrstaprofila_50_ili_70, ramfuk_sirinab, ramfuk_visinah,
    // ramfuk_a, ramfuk_c, // NJ 2024-09-16: Polja A i C su se koristila da bi mogli da proverimo sa crteža.
    ramfuk_materijal_lim,
  } = state;



  // Broj Crteža, po formuli
  const G7 = kolicina;
  const B7 = ramfuk_tipfiltera;

  const broj_crteza = XIF(G7 === "", "",
    XIF(OR(B7 === "VRECASTI_25_PANELNI_48", B7 === "VRECASTI_25_PANELNI_92"), "P01-24-B", "P01-24-A"));

  const B13 = broj_crteza;
  // const C7 = ksirinaoznaka; // TODO oznaka sifine komore
  const D7 = kvisinaoznaka; // TODO oznaka visine komore
  // const E7 = tervrstaprofila_50_ili_70;
  const E7 = Number.parseInt(tervrstaprofila_50_ili_70); // FIX

  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(ramfuk_materijal_lim);
  const _tipmetalalima = _mat_params.naziv_materijala;
  const F7 = _tipmetalalima;

  // Ident, po formuli 
  // const ident = XIF(G7 === "", "", B13 + "-" + C7 + "." + D7 + "-" + SWITCH(B7, "VRECASTI_25", 25, "PANELNI_48", 48, "PANELNI_92", 92, "VRECASTI_25_PANELNI_48", "25-48", "VRECASTI_25_PANELNI_92", "25-82") + "-" + XIF(E7 === 50, "P50", XIF(E7 === 70, "P70")) + "-" + XIF(F7 === "Pocinkovani", "GS", XIF(F7 === "Prohrom", "SS"))); // ovde sam umesto "Pocinkovano" prepravio u "Pocinkovani"

  /*
  Širinu E13, po formuli =IF(G7="","",
  XLOOKUP(C7,PARAMETRI!$AB$2:$AB$15,PARAMETRI!$AD$2:$AD$15-2))
  *Ovu formulu preskoci, jer funckija XLOOKUP ne radi kod nas.
  */
  // DL: E13 je polje koje se zove Širina B (širina celog rama) i ona se izracunava E13 = msirinaunutrasnjaizmedjupregradnih - zazor 2mm.
  const E13 = ramfuk_sirinab;

  /*
  Visinu F13, po formuli =IF(G7="","",
  SWITCH($E7,
    50,XLOOKUP(D7,PARAMETRI!$AF$2:$AF$10,PARAMETRI!$AJ$2:$AJ$10-2),
    70,XLOOKUP(D7,PARAMETRI!$AF$2:$AF$10,PARAMETRI!$AK$2:$AK$10-2) ) )
    *Ovu formulu preskoci, jer funckija XLOOKUP ne radi kod nas.
    */
  // DL: F13 je polje koje se zove Visina H (širina celog rama) i ona se izracunava F13 = mvisinaunutrasnjaizmedjupregradnih - zazor 2mm.
  const F13 = ramfuk_visinah;

  /*
  // const A = F13 - 10;
  const A = ramfuk_a;
  // const C = E13 - 4;
  const C = ramfuk_c;
  */

  // TODO
  const protobomp_superdata = {
    ramfuk_tipfiltera,
    ramfuk_sirinab,
    ramfuk_visinah,
    tervrstaprofila_50_ili_70,
  };

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$ramfuk"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_ramfilteranauklizavanje_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  // 1.
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$ramfuk/SKLOP_RAMFUK',
    identmaterijala: ramfuk_materijal_lim,
    naziv: 'Ram filtera na uklizavanje ?',
    kolicina: kolicina,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true });
  const { created_tempkey: sklop_ramfuk } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  if (true) {
    //
    //
    // 2. P1 Vertikalni nosac levi Količina (kom) =$G$7*1
    if (true) {
      const item = {
        tempkey: 1,
        tip: "VERTIKALNI_NOSAC_LEVI",
        pbnode_family: 'terkk$ramfuk/NOSAC_V_LEVI',
        naziv: '? Vertikalni nosac levi',
        kolicina: (G7 * 1),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
    // 3. P2 Vertikalni nosac desni =$G$7*1
    if (true) {
      const item = {
        tempkey: 2,
        pbnode_family: 'terkk$ramfuk/NOSAC_V_DESNI',
        tip: "VERTIKALNI_NOSAC_DESNI",
        naziv: 'Vertikalni nosac desni',
        kolicina: (G7 * 1),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
    // 4. P3 Nosac omega =$G$7*2
    if (true) {
      let item_jednodelni;
      const item = {
        tempkey: 3,
        tip: "NOSAC_OMEGA",
        pbnode_family: 'terkk$ramfuk/NOSAC_OMEGA',
        naziv: '? Nosac omega',
        kolicina: (G7 * 2),
        razvijenamera1: ramfuk_sirinab, // sirina
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // Napomena: Ovaj element bude iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P5.1 P5.2
      // PREPOLOVLJAVANJE MEHANIZAM sa deljenjem na pola na razlicite .1 i .2 delove
      if (item.razvijenamera1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dvodelno
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$ramfuk/NOSAC_OMEGA_1_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$ramfuk/NOSAC_OMEGA_2_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
      } else { // PREPOLOVLJAVANJE MEHANIZAM CASE jednodelno
        if (true) {
          const item = item_jednodelni;
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
      }
    }
    // 5. P4 Klizac gornji =IFS(F13<830,1,F13<1300,2,F13<1900,3)*G7
    // const E22 = (IFS(F13 < 830, 1, F13 < 1300, 2, F13 < 1900, 3) * G7); // GRESKA: U ovoj fomuli nije pokriven slucaj kad je F13 tj. ramfuk_visinah > 1900
    const E22 = (IFS(F13 < 830, 1, F13 < 1300, 2, F13 < 1900, 3, (F13 === 1900 || F13 > 1900), 4) * G7); // NJ: U svim ostalim slučajevima treba da E22 deo P4 ima količinu 4. A ako je dvodelni ide ih 8.
    const kolicina_p4_delova = E22;
    console.log('E22', E22, 'F13', F13, 'G7', G7, 'kolicina_p4_delova', kolicina_p4_delova);
    if (true) {
      let item_jednodelni;
      const item = {
        tempkey: 4,
        tip: "KLIZAC_GORNJI",
        pbnode_family: 'terkk$ramfuk/KLIZAC_GORNJI',
        naziv: 'Klizac gornji',
        // kolicina: E22,
        kolicina: kolicina_p4_delova,
        razvijenamera1: ramfuk_sirinab,
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // Napomena: Ovaj element bude iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P4.1 P4.2
      // PREPOLOVLJAVANJE MEHANIZAM sa deljenjem na pola na razlicite .1 i .2 delove
      if (item.razvijenamera1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dvodelno
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$ramfuk/KLIZAC_GORNJI_1_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$ramfuk/KLIZAC_GORNJI_2_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
      } else { // PREPOLOVLJAVANJE MEHANIZAM CASE jednodelno
        if (true) {
          const item = item_jednodelni;
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
      }
    }
    // 6. P5 Klizac donji =E22
    const E23 = E22;
    const kolicina_p5_delova = E23;
    if (true) {
      let item_jednodelni;
      const item = {
        tempkey: 5,
        tip: "KLIZAC_DONJI",
        pbnode_family: 'terkk$ramfuk/KLIZAC_DONJI',
        naziv: 'Klizac donji',
        // kolicina: E23,
        kolicina: kolicina_p5_delova,
        razvijenamera1: ramfuk_sirinab,
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      item_jednodelni = item;
      // Napomena: Ovaj element bude iz dva dela, onda se dužina deli na pola. CNC program dobija vrednosti P5.1 P5.2
      // PREPOLOVLJAVANJE MEHANIZAM sa deljenjem na pola na razlicite .1 i .2 delove
      if (item.razvijenamera1 > 2440) { // PREPOLOVLJAVANJE MEHANIZAM CASE dvodelno
        const _prepolovljena_duzina = ROUNDDOWN(item.razvijenamera1 / 2); // NJ 2024-04-09: Kada delimo elemente na pola, kao što je pomenuto u prethodnoj stavci, potrebno je novu dimenziju zaokružiti na broj manje
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$ramfuk/KLIZAC_DONJI_1_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
        if (true) {
          const item = {
            ...item_jednodelni,
            pbnode_family: 'terkk$ramfuk/KLIZAC_DONJI_2_2',
            razvijenamera1: _prepolovljena_duzina,
            kolicina: item_jednodelni.kolicina, // kolicina ostaje ista samo sto se pravi iz dva razlicita dela
          }
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
      } else { // PREPOLOVLJAVANJE MEHANIZAM CASE jednodelno
        if (true) {
          const item = item_jednodelni;
          _pbnode_dirty_enrich(item, protobomp_superdata, true);
          const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
          protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
        }
      }
    }
    // 7. P6 Granicnik 288 mm =IF(OR(D7="03",D7="09",D7="15"),1*G7,0)
    if (true) {
      console.log('* * * * *');
      console.log('D7', D7);
      console.log('OR(D7 === "03", D7 === "09", D7 === "15")', OR(D7 === "03", D7 === "09", D7 === "15"));
      console.log('XIF(OR(D7 === "03", D7 === "09", D7 === "15"), 1 * G7, 0)', (XIF(OR(D7 === "03", D7 === "09", D7 === "15"), 1 * G7, 0)));
      const item = {
        tempkey: 6,
        tip: "GRANICNIK_288",
        pbnode_family: 'terkk$ramfuk/GRANICNIK_288',
        naziv: 'Granicnik 288 mm',
        kolicina: (XIF(OR(D7 === "03", D7 === "09", D7 === "15"), 1 * G7, 0)),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
    // 8. P7 Granicnik 493 mm =IF(OR(D7="05"),1*G7,0)
    if (true) {
      const item = {
        tempkey: 7,
        tip: "GRANICNIK_493",
        pbnode_family: 'terkk$ramfuk/GRANICNIK_493',
        naziv: 'Granicnik 493 mm',
        kolicina: (XIF(OR(D7 === "05"), 1 * G7, 0)),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
    // 9. P7 Granicnik 593 mm =ROUNDDOWN(F13/610,0)*G7
    if (true) {
      const item = {
        tempkey: 8,
        tip: "GRANICNIK_593",
        pbnode_family: 'terkk$ramfuk/GRANICNIK_593',
        naziv: 'Granicnik 593 mm',
        kolicina: (ROUNDDOWN(F13 / 610, 0) * G7),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }

    // 10. P8.1 “FILTER NA UKLIZAVANJE- GRANICNIK 593mm P8.1“
    // Vertikalno ojacanje U profil =ROUNDDOWN($E13/610,0)*G7
    if (true) {
      const item = {
        tempkey: 9,
        tip: "VERTIKALNO_OJACANJE",
        pbnode_family: 'terkk$ramfuk/OJACANJE_V_UPROFIL_1',
        naziv: 'Vertikalno ojacanje U profil P8.1',
        kolicina: (ROUNDDOWN(E13 / 610, 0) * G7),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }

    // 11. P8.2 “FILTER NA UKLIZAVANJE- GRANICNIK 593mm P8.2“
    // 2024-07-10: P8 prelazi u P8.1 a za njega se nituje jos jedan malo vecu P8.2 koji je skoro isti i nituje se preko ovog. duzine su im iste 
    if (true) {
      const item = {
        tempkey: 9,
        tip: "VERTIKALNO_OJACANJE",
        pbnode_family: 'terkk$ramfuk/OJACANJE_V_UPROFIL_2',
        naziv: 'Vertikalno ojacanje U profil P8.2',
        kolicina: (ROUNDDOWN(E13 / 610, 0) * G7),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }

    // 12. P9 Distancer duplog klizaca =IF(OR($B7="VRECASTI_25_PANELNI_48",$B7="VRECASTI_25_PANELNI_92"),$E22+$E23,0)
    if (true) {
      const item = {
        tempkey: 10,
        tip: "DISTANCER_DUPLOG_KLIZACA",
        pbnode_family: 'terkk$ramfuk/DISTANCER_DUPLOG_KLIZACA',
        naziv: 'Distancer duplog klizaca',
        kolicina: (XIF(OR(B7 === "VRECASTI_25_PANELNI_48", B7 === "VRECASTI_25_PANELNI_92"), E22 + E23, 0)),
        identmaterijala: ramfuk_materijal_lim,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
    //
    //
    // ------ dodavanje direktnih materijala jos dva direktna materijala
    const ramfuk_zaptivac_kolicina = ROUNDUP(((kolicina_p4_delova + kolicina_p5_delova) * ramfuk_sirinab) / 1000, 3);  // KONVETROVANO U METRE i zaokruzeno na 3 decimale
    const ramfuk_zaptivna_traka_kolicina = ROUNDUP((4 * ramfuk_sirinab) / 1000, 3); // KONVETROVANO U METRE i zaokruzeno na 3 decimale kao kod panela
    // 13.
    if (true) {
      const item = {
        tempkey: 140,
        naziv: 'OSTALO ZAPTIVACI G003 F 1',
        // pbnode_family: 'terkk$ramfuk/?',
        kolicina: ramfuk_zaptivac_kolicina, //
        jm: tclocal.JM_M,
        terkategorija: "M",
        identcustom: "B100010000000071",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
    // 14.
    if (true) {
      const item = {
        tempkey: 140,
        naziv: "TRAKA ZAPTIVNA AROSIO 20X4",
        // pbnode_family: 'terkk$ramfuk/?',
        kolicina: ramfuk_zaptivna_traka_kolicina, //
        jm: tclocal.JM_M,
        terkategorija: "M",
        identcustom: "A040000000000009",
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ramfuk);
    }
  }
  //
  //
  return {
    svasta: {},
    _arr,
    _protobomp,
  }; // TODO
};



///////////

export const derivatPoluproizvod_ramfilteranauklizavanje_naziv = (tip, duzina) => {
  let naziv = '???';

  return naziv;
};


export const derivatPoluproizvod_ramfilteranauklizavanje_cncprogram = (tip,) => {
  let cnc_program = null;

  // TODO

  return cnc_program;
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_ramfilteranauklizavanje_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_ramfilteranauklizavanje_children = (v_input, _unbundled_subDraftel_arr) => {
  console.log('derAutoCreateVirbom_terkk_ramfilteranauklizavanje_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // PETLJA---------
  let _counterSubdraftelArrItem = 0;
  console.log(typeof _unbundled_subDraftel_arr);
  console.log(Array.isArray(_unbundled_subDraftel_arr));
  console.log(_unbundled_subDraftel_arr);
  _unbundled_subDraftel_arr.forEach((subDraftel) => {
    // EACH
    _counterSubdraftelArrItem++;
    let _derkey = 'der_virtel_child_' + _counterSubdraftelArrItem;


    // derivat EACH local 1 - OPERACIJA 2. OPSAV ERMAKSAN
    _derivat_key = _derkey;
    const _params_op2 = {
      "virtelclass": "terkk$ramfilteranauklizavanje$child",
      "terkategorija": "PP",
      "tergrupa": "LIM",
      "operacija": "OPSAV",
      "rc": "RCPRSER",
      "angazovanihradnika": 1,
      "vremepripreme": 0,
      "vremeoperacije": 0,
      "vremeugradnje": 0,
      "jm": "kom",
    };
    x = {
      _derivat_key,
      virtelschemakey: "terkk$ramfilteranauklizavanje$child",
      tip: subDraftel.tip,
      naziv: subDraftel.naziv,
      duzina: subDraftel.duzina,
      kolicina: subDraftel.kolicina,
      ..._params_op2,
      ..._getParamsFromLib("terkk$ramfilteranauklizavanje$child"),
    }; // parametri na kraju imaju prioritet
    x._materijal_naziv = x.naziv + '_m ???';
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // derivat EACH local 1 - OPERACIJA 1. OPSEC AMADA 
    _derivat_key = _derkey + '.1';
    const _params_op1 = {
      "virtelclass": "terkk$ramfilteranauklizavanje$child",
      "terkategorija": "PP",
      "tergrupa": "LIM",
      "operacija": "OPSEC",
      "rc": "RCPRBAM",
      "angazovanihradnika": 1,
      "vremepripreme": 0,
      "vremeoperacije": 0,
      "vremeugradnje": 0,
      "jm": "kom",
    };
    xx = {
      _derivat_key,
      virtelschemakey: "terkk$ramfilteranauklizavanje$child",
      tip: subDraftel.tip,
      naziv: subDraftel.naziv,
      duzina: subDraftel.duzina,
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      ..._params_op1,
      ..._getParamsFromLib("terkk$ramfilteranauklizavanje$child"),
    }; // parametri na kraju imaju prioritet
    xx._materijal_naziv = x.naziv + '_m ???';
    z[_derivat_key] = x;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xx);


    // derivat EACH local 1.1.1
    _derivat_key = _derivat_key + '_m';
    // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    const _materijal_naziv = xx._materijal_naziv;
    // const tip = p.tip;
    const _kolicina = 999; // TODO
    xxm = {
      naziv: _materijal_naziv,
      calculated_ident: '???',
      terkategorija: 'M',
      kolicina: _kolicina, // ???
      jm: tclocal.JM_M2,
      //
      _derivat_key,
      // virtelschemakey: 'terkk$ppv$sekcija$materijal1'
      virtelschemakey: 'terkk$materijal_lim'
    };
    z[_derivat_key] = xxm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xxm);


  });  // end of PETLJA----------
  //


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

